import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UserJobGridSetting } from "app/Model/Dto/UserGridSettings/UserJobGridSetting";
import { lastValueFrom } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class UserSettingsService {
  private readonly apiUrl = "api/UserJobGridSetting";

  constructor(private http: HttpClient) {}

  getGridState(): Promise<UserJobGridSetting> {
    const url = `${this.apiUrl}/GetUserJobGridSettings`;
    return lastValueFrom(this.http.get<UserJobGridSetting>(url)  as any);
  }

  saveGridState(setting: UserJobGridSetting): Promise<void> {
    const url = `${this.apiUrl}/SaveUserJobGridSettings`;
    return lastValueFrom(this.http.post<void>(url, setting)  as any);
  }
}
